import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as SunSvg } from './assets/sun.svg';

const SunIcon = React.forwardRef((args, ref) => <SvgIcon component={SunSvg} ref={ref} {...args} />);

export default SunIcon;
